import { render, staticRenderFns } from "./removeDepartment.vue?vue&type=template&id=c5c3216a&scoped=true"
import script from "./removeDepartment.vue?vue&type=script&lang=js"
export * from "./removeDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c3216a",
  null
  
)

export default component.exports